import autoPlural from 'plur';

const digits = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];

/**
 * Create a string with a singular or plural value.
 * See pluralize.spec.js for examples
 * @param {Number} count  The number of items
 * @param {String} singular  The singular name for one item
 * @param {Object} when  An object with keys 0, 1, 2, ... and "other" with various cases
 * @param {Number} offset  The number to subtract from count if when cases contain "{}" as a placeholder
 * @return {String}
 */
export default function pluralize({ count, singular, when, offset = 0 }) {
	if (typeof singular !== 'string' && typeof when !== 'object') {
		throw new Error('A singular String or when Object is required');
	}
	let tpl;
	if (!when && singular) {
		if (count === 1) {
			return `1 ${singular}`;
		}
		tpl = '{} ' + autoPlural(singular, 2);
	} else {
		tpl = when[String(count)] || when[String(digits[count])] || when.other || '';
	}
	return tpl.replace(/{}/g, String(count - offset));
}
